import { render, staticRenderFns } from "./DistressalertssitrepForm.vue?vue&type=template&id=752ffd01"
import script from "./DistressalertssitrepForm.vue?vue&type=script&lang=js"
export * from "./DistressalertssitrepForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports